import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBbYG765mlhLSzz2NcJOBLHF7sMRm_1T00",
    authDomain: "markdown-converter-pdf-doc.firebaseapp.com",
    projectId: "markdown-converter-pdf-doc",
    storageBucket: "markdown-converter-pdf-doc.firebasestorage.app",
    messagingSenderId: "624142376439",
    appId: "1:624142376439:web:47f01f118f94656ee2e2f2",
    measurementId: "G-PCX3S3T905",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const analytics = getAnalytics(app);
